<div class="aspect-group">
	<div class="flex align-center flex-spread">
		<span class="completed-summary">Completed {{completed}}/{{aspects.length}}</span>
		<mat-slide-toggle [checked]="showAllAspects" (change)="onToggleChange($event)" hideIcon color="#022a4d"
			labelPosition="before">
			<div class="toggle-label">Show previously completed aspects</div>
		</mat-slide-toggle>
	</div>

	<div class="aspects-container flex-column">
		<ng-content></ng-content>
	</div>
</div>